<template>
  <div class="tb-container">
    <div class="select-box">
      <div class="left">
        <van-field
          readonly
          clickable
          :value="productName"
          placeholder="请选择产品"
          :right-icon="showProductPicker ? 'arrow-up' : 'arrow-down'"
          @click="showProductPicker = true"
        />
      </div>
      <div class="right">
        <van-field
          readonly
          clickable
          :value="categoryName"
          placeholder="请选择险种"
          :right-icon="showCategoryPicker ? 'arrow-up' : 'arrow-down'"
          @click="showCategoryPicker = true"
        />
      </div>
    </div>
    <div class="input-box">
      <div class="left">
        <van-field
          readonly
          clickable
          :value="stateName"
          placeholder="请选择保单状态"
          :right-icon="showStatePicker ? 'arrow-up' : 'arrow-down'"
          @click="showStatePicker = true"
        />
      </div>
      <div class="right">
        <van-field
          v-model="queryParams.search"
          placeholder="请输入姓名，保单号"
          right-icon="search"
        />
      </div>
    </div>
    <div class="date-box">
      <div class="left">
        <van-field
          readonly
          clickable
          :value="dateName"
          placeholder="选择开始和结束日期"
          right-icon="arrow-down"
          @click="showCalendar = true"
        />
      </div>
      <div class="right">
        <van-button type="info" @click="handleSearchClick">查询</van-button>
        <van-button icon="replay" type="primary" @click="handleReplayClick" />
      </div>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="_getInsureList"
    >
      <div class="list-box">
        <div class="list-item" v-for="item in tbList" :key="item.id">
          <div class="title-box">
            <div class="title-left">保单号：{{ item.policyNo }}</div>
            <div class="title-right">
              <div class="right-icon-success" v-if="item.state == 2">
                已支付
              </div>
              <div
                class="right-icon-warning"
                v-else
                @click="handlePayClick(item)"
              >
                {{ getStateName(item.state) }}
              </div>
            </div>
          </div>
          <div class="line"></div>
          <div class="content-box">
            <p class="content-item">姓名：{{ item.insureName }}</p>
            <p class="content-item" style="margin: 10px 0px">
              投保方案：{{ item.category.name }}
            </p>
            <p class="content-item">推广人：{{ item.belonger.nickname }}</p>
          </div>
          <div class="line"></div>
          <div class="content-bottom" style="color: #777777">
            投保时间：{{ item.createTime }}
          </div>
        </div>
      </div>
    </van-list>
    <van-calendar
      v-model="showCalendar"
      type="range"
      :min-date="getDate(2)"
      @confirm="handleCalendarClick"
    />
    <van-popup v-model="showProductPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="productList"
        @confirm="handleProductPickerOk"
        @cancel="showProductPicker = false"
      />
    </van-popup>
    <van-popup v-model="showCategoryPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="categoryList"
        @confirm="handleCategoryPickerOk"
        @cancel="showCategoryPicker = false"
      />
    </van-popup>
    <van-popup v-model="showStatePicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="stateList"
        @confirm="handleStatePickerOk"
        @cancel="showStatePicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { findProductById, getInsureList } from "@/api/common";
export default {
  data() {
    return {
      showProductPicker: false,
      showCategoryPicker: false,
      showStatePicker: false,
      productName: "",
      categoryName: "",
      dateName: "",
      stateName: "",
      queryParams: {
        productId: "",
        categoryId: "",
        search: "",
        beginDate: "",
        endDate: "",
        page: 0,
        state: "",
      },
      stateList: [
        { value: 1, name: "未支付" },
        { value: 2, name: "投保成功" },
        { value: 4, name: "已退保" },
      ],
      showCalendar: false,
      productList: [],
      categoryList: [],
      tbList: [],
      loading: false,
      finished: false,
      productId: "",
    };
  },
  created() {
    document.title = "保单列表";
    this.productId = this.$route.query.id || "";
    this._getAllProduct();
    this._getInsureList();
  },
  methods: {
    _getAllProduct() {
      findProductById({id:this.productId}).then((res) => {
        if (res.code == 0) {
          this.productList = [res.data];
        }
      });
    },
    _getInsureList() {
      this.loading = true;
      this.queryParams.page++;
      getInsureList(this.queryParams).then((res) => {
        this.loading = false;
        if (res.code == 0) {
          if (this.tbList.length == 0) {
            this.tbList = res.data.list;
          } else {
            this.tbList = this.tbList.concat(res.data.list);
          }
          if (res.data.list.length < 10) {
            this.finished = true;
          }
        }
      });
    },
    getStateName(state) {
      let sFlag = "";
      if (state == 0) {
        sFlag = "失败";
      } else if (state == 1) {
        sFlag = "未支付";
      } else if (state == 4) {
        sFlag = "已退保";
      }
      return sFlag;
    },
    handlePayClick(item) {
      let cDate = this.$DateTools.formatDatetime(
        "yyyy-MM-dd",
        new Date(item.createTime)
      );
      let dDate = this.$DateTools.formatDatetime("yyyy-MM-dd", new Date());
      if (item.state == 1 && cDate == dDate && this.queryParams.state == "") {
        window.location.href = item.payUrl;
      }
    },
    handleSearchClick() {
      this.queryParams.page = 0;
      this.finished = false;
      this.tbList = [];
      this._getInsureList();
    },
    handleReplayClick() {
      this.productName = "";
      this.categoryName = "";
      this.dateName = "";
      this.stateName = "";
      this.queryParams.productId = "";
      this.queryParams.categoryId = "";
      this.categoryList = [];
      this.queryParams.search = "";
      this.queryParams.beginDate = "";
      this.queryParams.endDate = "";
      this.queryParams.page = 0;
      this.queryParams.state = "";
      this.finished = false;
      this.tbList = [];
      this._getInsureList();
    },
    handleCalendarClick(date) {
      const [start, end] = date;
      this.dateName =
        this.$DateTools.formatDatetime("yyyy/MM/dd", start) +
        "-" +
        this.$DateTools.formatDatetime("yyyy/MM/dd", end);
      this.queryParams.beginDate = start;
      this.queryParams.endDate = end;
      this.showCalendar = false;
    },
    handleProductPickerOk(e) {
      this.productName = e.name;
      this.queryParams.productId = e.id;
      this.categoryName = "";
      this.queryParams.categoryId = "";
      this.categoryList = e.categoryList;
      this.showProductPicker = false;
    },
    handleCategoryPickerOk(e) {
      this.categoryName = e.name;
      this.queryParams.categoryId = e.id;
      this.showCategoryPicker = false;
    },
    handleStatePickerOk(e) {
      this.stateName = e.name;
      this.queryParams.state = e.value;
      this.showStatePicker = false;
    },
    getDate(number) {
      var nowdate = new Date();
      nowdate.setFullYear(nowdate.getFullYear() - number);
      var y = nowdate.getFullYear();
      var m = nowdate.getMonth() + 1;
      var d = nowdate.getDate();
      var retrundate = y + "/" + m + "/" + d;
      return new Date(retrundate);
    },
  },
};
</script>

<style lang="scss" scoped>
.tb-container {
  width: 100%;
  min-height: 100%;
  background-color: #f2f2f2;
  padding: 10px;
  .select-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .left,
    .right {
      width: 48%;
    }
  }
  .input-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .left,
    .right {
      width: 48%;
    }
  }
  .date-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .left {
      width: 65%;
    }
    .right {
      width: 32%;
      display: flex;
      justify-content: space-between;
      & /deep/ .van-button--normal {
        // width: 100%;
        height: 35px;
        line-height: 35px;
        width: 65%;
      }
      & /deep/ .van-button--primary {
        height: 35px;
        line-height: 35px;
        padding: 0 10px;
        width: 32%;
      }
    }
  }
  .list-box {
    width: 100%;
    .list-item {
      width: 100%;
      display: flex;
      flex-direction: column;
      background-color: white;
      border-radius: 8px;
      margin-bottom: 10px;
      .line {
        width: 100%;
        border-bottom: 1px solid #f2f2f2;
      }
      .title-box {
        width: 100%;
        padding: 10px 15px;
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &::before {
          content: "";
          position: absolute;
          width: 2px;
          height: 50%;
          background-color: #1b6df6;
          left: 1px;
        }
        .title-right {
          height: 100%;
          .right-icon-success {
            background-color: green;
            width: 70px;
            height: 20px;
            color: white;
            text-align: center;
            border-top-left-radius: 10px;
            border-bottom-left-radius: 10px;
            position: relative;
            right: -20px;
            &::after {
              content: "";
              position: absolute;
              width: 5px;
              height: 5px;
              bottom: -5.5px;
              right: -6px;
              border: 6px solid transparent;
              border-left-color: green;
            }
          }
          .right-icon-warning {
            background-color: #e87712;
            width: 70px;
            height: 20px;
            color: white;
            text-align: center;
            border-top-left-radius: 10px;
            border-bottom-left-radius: 10px;
            position: relative;
            right: -20px;
            &::after {
              content: "";
              position: absolute;
              width: 5px;
              height: 5px;
              bottom: -5.5px;
              right: -6px;
              border: 6px solid transparent;
              border-left-color: #e87712;
            }
          }
        }
      }
      .content-box {
        width: 100%;
        padding: 10px 15px;
        position: relative;
      }
      .content-bottom {
        width: 100%;
        padding: 10px 15px;
        position: relative;
      }
    }
  }
  & /deep/ .van-cell {
    line-height: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/insurance/tb_list.vue